import { colors } from '../../colors';
var input = {
  textColor: colors.black
};
export default input;